<ng-container *ngIf="texts$ | async as texts">
    <button
        tuiIconButton
        tuiPreviewAction
        type="button"
        class="t-arrow_left"
        [disabled]="leftButtonDisabled"
        [icon]="icons.prev"
        [title]="texts[0]"
        (click)="onArrowClick(-1)"
    ></button>
    {{ index + 1 }}/{{ length }}
    <button
        tuiIconButton
        tuiPreviewAction
        type="button"
        class="t-arrow_right"
        [disabled]="rightButtonDisabled"
        [icon]="icons.next"
        [title]="texts[1]"
        (click)="onArrowClick(1)"
    ></button>
</ng-container>
